import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'duration',
})
export class DurationPipe implements PipeTransform {

  transform(seconds: number): string {
    if (seconds < 60) {
      return `${seconds.toFixed(0)}s`;
    }

    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);

    if (minutes < 60) {
      return remainingSeconds === 0
          ? `${minutes}m`
          : `${minutes}m ${remainingSeconds}s`;
    }

    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    if (hours < 24) {
      if (remainingMinutes === 0 && remainingSeconds === 0) {
        return `${hours}h`;
      }
      if (remainingSeconds === 0) {
        return `${hours}h ${remainingMinutes}m`;
      }
      return `${hours}h ${remainingMinutes}m ${remainingSeconds}s`;
    }

    const days = Math.floor(hours / 24);
    const remainingHours = hours % 24;

    if (days < 365) {
      let res = `${days}d`;
      if (remainingHours > 0) res += ` ${remainingHours}h`;
      if (remainingMinutes > 0) res += ` ${remainingMinutes}m`;
      if (remainingSeconds > 0) res += ` ${remainingSeconds}s`;
      return res;
    }

    const years = Math.floor(days / 365);
    const remainingDays = days % 365;

    let result = `${years}y`;
    if (remainingDays > 0) result += ` ${remainingDays}d`;
    if (remainingHours > 0) result += ` ${remainingHours}h`;
    if (remainingMinutes > 0) result += ` ${remainingMinutes}m`;
    if (remainingSeconds > 0) result += ` ${remainingSeconds}s`;
    return result;
  }

}
